"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Exclamation = exports.ConfirmDialog = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var classNames = require("classnames");
require("./styles.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ConfirmDialog'), recompose_1.pure);
exports.ConfirmDialog = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { overlayClassName: classNames('confirm-dialog', props.overlayClassName), isOpen: props.isOpen, className: classNames('confirm-dialog-content', props.className) },
    React.createElement(sok_ui_1.Header, { className: 'header', onClose: props.close }, props.header),
    React.createElement(sok_ui_1.Container, { className: 'content' }, props.body),
    React.createElement(sok_ui_1.Footer, { className: 'footer' }, props.footer))); });
var enhanceExclamation = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Exclamation'), recompose_1.pure);
exports.Exclamation = enhanceExclamation(function (props) { return (React.createElement("div", { className: classNames('icon fa-stack fa-2x', props.className) },
    React.createElement(sok_ui_1.Icon, { className: 'fa-light fa-triangle fa-stack-2x red', prefix: 'fal' }),
    React.createElement(sok_ui_1.Icon, { className: 'fa-light fa-exclamation fa-stack-1x black', prefix: 'fa' }))); });
